export default __webpack_public_path__ + "static/media/easy_payment_options.d42c4b56.svg";